"use client";

import { useMemo } from "react";
import Link from "next/link";
import { useWebInfoStore } from "context/webInfoStore";
import { languageBuild } from "lib/language";
import styles from "styles/pages/categories.module.css";

export default function CategoriesPage() {
  const menuItems = useWebInfoStore((state) => state.menus);
  const lang = "mn";

  const computedMenus = useMemo(() => {
    if (!Array.isArray(menuItems)) return [];
    return menuItems;
  }, [menuItems]);

  const getMenuHref = (menu) => {
    const {
      linkType,
      url,
      internalPath,
      path,
      slug,
      direct,
      model,
      newsCategory,
      isDirect,
      isModel,
      isCategory,
    } = menu || {};

    if (linkType === "externalUrl") return url || "#";
    if (linkType === "internalPath") return path || internalPath || "#";
    if (linkType === "internalPage" || linkType === "pageList") {
      return `/page/${slug || ""}`;
    }
    if (linkType === "subMenuList") {
      return `/page/${slug || ""}`;
    }

    if (isDirect) return direct || "#";
    if (isModel) return model ? `/${model}` : "#";
    if (isCategory)
      return newsCategory ? `/news?categories=${newsCategory}` : "#";

    if (direct) return direct;
    if (model) return `/${model}`;
    if (slug) return `/page/${slug}`;
    return path || internalPath || "#";
  };

  const getMenuName = (menu) => {
    return languageBuild(menu, "name", lang) || menu?.name || "Цэс";
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Ангилал</h1>
      </div>

      <div className={styles.categoriesList}>
        {computedMenus.map((menu, index) => {
          const href = getMenuHref(menu);
          const name = getMenuName(menu);
          const hasSubMenus =
            Array.isArray(menu.subMenus) && menu.subMenus.length > 0;

          return (
            <div key={menu._id || index} className={styles.categoryItem}>
              <Link href={href} className={styles.categoryLink}>
                <div className={styles.categoryContent}>
                  <div className={styles.categoryInfo}>
                    <span className={styles.categoryName}>{name}</span>
                    {hasSubMenus && (
                      <span className={styles.subMenuCount}>
                        {menu.subMenus.length} дэд ангилал
                      </span>
                    )}
                  </div>
                </div>
              </Link>

              {hasSubMenus && (
                <div className={styles.subMenusList}>
                  {menu.subMenus.map((subMenu, subIndex) => {
                    const subHref = getMenuHref(subMenu);
                    const subName = getMenuName(subMenu);

                    return (
                      <Link
                        key={subMenu._id || subIndex}
                        href={subHref}
                        className={styles.subMenuItem}
                      >
                        <span className={styles.subMenuName}>{subName}</span>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {computedMenus.length === 0 && (
        <div className={styles.emptyState}>
          <p className={styles.emptyText}>Ангилал олдсонгүй</p>
        </div>
      )}
    </div>
  );
}
